var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeekOffCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 84,
    viewBox: "0 0 114 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 114,
    height: 84,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin Flow"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -58,
    y: -288,
    width: 360,
    height: 800,
    rx: 12,
    fill: "#021239"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 422199"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2892_239)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -38,
    y: -34,
    width: 152,
    height: 118,
    rx: 12,
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2303",
    opacity: 0.08,
    cx: 73,
    cy: 73,
    r: 73,
    fill: "url(#paint0_linear_2892_239)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1973352872"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1973352837"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1973352834"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M47.5922 22.2578H84.1722C86.8522 22.2578 89.0222 24.4278 89.0222 27.1078V56.1678C89.0222 58.8478 86.8522 61.0178 84.1722 61.0178H82.5992C81.8536 61.0178 81.3703 61.8043 81.707 62.4694L84.3504 67.6917C84.8729 68.7239 83.5173 69.6714 82.7275 68.826L75.7286 61.3351C75.5395 61.1327 75.2749 61.0178 74.9979 61.0178H47.5922C44.9122 61.0178 42.7422 58.8478 42.7422 56.1678V27.1078C42.7422 24.4278 44.9122 22.2578 47.5922 22.2578Z",
    fill: "url(#paint1_linear_2892_239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M81.6859 19.6406H50.0859C48.9814 19.6406 48.0859 20.5361 48.0859 21.6406V50.8306C48.0859 53.0398 49.8768 54.8306 52.0859 54.8306H79.6859C81.8951 54.8306 83.6859 53.0398 83.6859 50.8306V21.6406C83.6859 20.5361 82.7905 19.6406 81.6859 19.6406Z",
    fill: "url(#paint2_linear_2892_239)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1973352859"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 10868",
    x: 53,
    y: 31,
    width: 6,
    height: 6,
    rx: 2,
    fill: "#2C4071"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 10869",
    x: 63,
    y: 31,
    width: 6,
    height: 6,
    rx: 2,
    fill: "#2C4071"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 10871",
    x: 73,
    y: 31,
    width: 6,
    height: 6,
    rx: 2,
    fill: "#2C4071"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1973352860"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 10868_2",
    x: 53,
    y: 39,
    width: 6,
    height: 6,
    rx: 2,
    fill: "#2C4071"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 10869_2",
    x: 63,
    y: 39,
    width: 6,
    height: 6,
    rx: 2,
    fill: "#2C4071"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 10871_2",
    x: 73,
    y: 39,
    width: 6,
    height: 6,
    rx: 2,
    fill: "#2C4071"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1973352861"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 10868_3",
    x: 53,
    y: 47,
    width: 6,
    height: 6,
    rx: 2,
    fill: "#2C4071"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 10869_3",
    x: 63,
    y: 47,
    width: 6,
    height: 6,
    rx: 2,
    fill: "#2C4071"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 10871_3",
    x: 73,
    y: 47,
    width: 6,
    height: 6,
    rx: 2,
    fill: "#2C4071"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M81.6859 19.6406H50.0859C48.9814 19.6406 48.0859 20.5361 48.0859 21.6406V27.9006H83.6859V21.6406C83.6859 20.5361 82.7905 19.6406 81.6859 19.6406Z",
    fill: "#2C4071"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M53.8453 24.92C53.0753 24.92 52.4453 24.29 52.4453 23.52V18.4C52.4453 17.63 53.0753 17 53.8453 17C54.6153 17 55.2453 17.63 55.2453 18.4V23.52C55.2453 24.29 54.6153 24.92 53.8453 24.92Z",
    fill: "#4A5D8B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M59.8609 24.92C59.0909 24.92 58.4609 24.29 58.4609 23.52V18.4C58.4609 17.63 59.0909 17 59.8609 17C60.6309 17 61.2609 17.63 61.2609 18.4V23.52C61.2609 24.29 60.6309 24.92 59.8609 24.92Z",
    fill: "#4A5D8B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M65.8844 24.92C65.1144 24.92 64.4844 24.29 64.4844 23.52V18.4C64.4844 17.63 65.1144 17 65.8844 17C66.6544 17 67.2844 17.63 67.2844 18.4V23.52C67.2844 24.29 66.6544 24.92 65.8844 24.92Z",
    fill: "#4A5D8B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M71.9 24.92C71.13 24.92 70.5 24.29 70.5 23.52V18.4C70.5 17.63 71.13 17 71.9 17C72.67 17 73.3 17.63 73.3 18.4V23.52C73.3 24.29 72.67 24.92 71.9 24.92Z",
    fill: "#4A5D8B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M77.9234 24.92C77.1534 24.92 76.5234 24.29 76.5234 23.52V18.4C76.5234 17.63 77.1534 17 77.9234 17C78.6934 17 79.3234 17.63 79.3234 18.4V23.52C79.3234 24.29 78.6934 24.92 77.9234 24.92Z",
    fill: "#4A5D8B"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 1973352868"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 10872",
    x: 62,
    y: 51,
    width: 39,
    height: 22,
    rx: 5.25,
    fill: "#1D2B4E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 422280"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 54,
    width: 33,
    height: 16,
    rx: 4,
    fill: "url(#paint3_linear_2892_239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SUN",
    opacity: 0.7,
    d: "M75.2852 60.9258C75.2539 60.6107 75.1198 60.3659 74.8828 60.1914C74.6458 60.0169 74.3242 59.9297 73.918 59.9297C73.6419 59.9297 73.4089 59.9687 73.2188 60.0469C73.0286 60.1224 72.8828 60.2279 72.7813 60.3633C72.6823 60.4987 72.6328 60.6523 72.6328 60.8242C72.6276 60.9674 72.6576 61.0924 72.7227 61.1992C72.7904 61.306 72.8828 61.3984 73 61.4766C73.1172 61.5521 73.2526 61.6185 73.4062 61.6758C73.5599 61.7305 73.724 61.7773 73.8984 61.8164L74.6172 61.9883C74.9661 62.0664 75.2865 62.1706 75.5781 62.3008C75.8698 62.431 76.1224 62.5911 76.3359 62.7812C76.5495 62.9714 76.7148 63.1953 76.832 63.4531C76.9518 63.7109 77.013 64.0065 77.0156 64.3398C77.013 64.8294 76.888 65.2539 76.6406 65.6133C76.3958 65.9701 76.0417 66.2474 75.5781 66.4453C75.1172 66.6406 74.5612 66.7383 73.9102 66.7383C73.2643 66.7383 72.7018 66.6393 72.2227 66.4414C71.7461 66.2435 71.3737 65.9505 71.1055 65.5625C70.8398 65.1719 70.7005 64.6888 70.6875 64.1133H72.3242C72.3424 64.3815 72.4193 64.6055 72.5547 64.7852C72.6927 64.9622 72.8763 65.0964 73.1055 65.1875C73.3372 65.276 73.599 65.3203 73.8906 65.3203C74.1771 65.3203 74.4258 65.2786 74.6367 65.1953C74.8503 65.112 75.0156 64.9961 75.1328 64.8477C75.25 64.6992 75.3086 64.5286 75.3086 64.3359C75.3086 64.1562 75.2552 64.0052 75.1484 63.8828C75.0443 63.7604 74.8906 63.6562 74.6875 63.5703C74.487 63.4844 74.2409 63.4062 73.9492 63.3359L73.0781 63.1172C72.4036 62.9531 71.8711 62.6966 71.4805 62.3477C71.0898 61.9987 70.8958 61.5286 70.8984 60.9375C70.8958 60.4531 71.0247 60.0299 71.2852 59.668C71.5482 59.306 71.9089 59.0234 72.3672 58.8203C72.8255 58.6172 73.3464 58.5156 73.9297 58.5156C74.5234 58.5156 75.0417 58.6172 75.4844 58.8203C75.9297 59.0234 76.276 59.306 76.5234 59.668C76.7708 60.0299 76.8984 60.4492 76.9062 60.9258H75.2852ZM83.0947 58.625H84.7861V63.8203C84.7861 64.4036 84.6468 64.9141 84.3682 65.3516C84.0921 65.7891 83.7054 66.1302 83.208 66.375C82.7106 66.6172 82.1312 66.7383 81.4697 66.7383C80.8057 66.7383 80.2249 66.6172 79.7275 66.375C79.2301 66.1302 78.8434 65.7891 78.5674 65.3516C78.2913 64.9141 78.1533 64.4036 78.1533 63.8203V58.625H79.8447V63.6758C79.8447 63.9805 79.9111 64.2513 80.0439 64.4883C80.1794 64.7253 80.3695 64.9115 80.6143 65.0469C80.859 65.1823 81.1442 65.25 81.4697 65.25C81.7979 65.25 82.083 65.1823 82.3252 65.0469C82.57 64.9115 82.7588 64.7253 82.8916 64.4883C83.027 64.2513 83.0947 63.9805 83.0947 63.6758V58.625ZM92.8691 58.625V66.625H91.4082L87.9277 61.5898H87.8691V66.625H86.1777V58.625H87.6621L91.1152 63.6562H91.1855V58.625H92.8691Z",
    fill: "#021239"
  }))))), /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    y: -33.5,
    width: 151,
    height: 117,
    rx: 11.5,
    stroke: "url(#paint4_linear_2892_239)",
    strokeOpacity: 0.1
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2892_239",
    x1: 73,
    y1: -44,
    x2: 73,
    y2: 73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2892_239",
    x1: 65.8822,
    y1: 22.2578,
    x2: 65.8822,
    y2: 76.3828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B5F93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B4F7B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2892_239",
    x1: 65.8859,
    y1: 19.6406,
    x2: 65.8859,
    y2: 59.8828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5470B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#576B9C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2892_239",
    x1: 81.5,
    y1: 54,
    x2: 81.5,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6377A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#314577"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2892_239",
    x1: -38,
    y1: -37,
    x2: 38,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2892_239"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -38,
    y: -34,
    width: 152,
    height: 118,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeekOffCardIcon);
export default __webpack_public_path__ + "static/media/WeekOffCardIcon.092ffb79cf5b73628e3a430ac1306dc2.svg";
export { ForwardRef as ReactComponent };